class BSPopover extends HTMLElement {
  connectedCallback() {
    this.options = {};

    if(this.dataset.bsTrigger != undefined)
      this.options.trigger = this.dataset.bsTrigger;
    
    new bootstrap.Popover(this, this.options);
  }
}
if (!window.customElements.get("bs-popover")) {
  window.customElements.define("bs-popover", BSPopover);
}
class BSTooltip extends HTMLElement {
  bt;

  connectedCallback() {
    this.bt = new bootstrap.Tooltip(this, {});
  }
}
if (!window.customElements.get("bs-tooltip")) {
  window.customElements.define("bs-tooltip", BSTooltip);
}

class BSModal extends HTMLElement {
  delay; modal; scroll; scrollHandler; cansShow; days;

  connectedCallback(){
    this.init();
  } 

  init = () => {
    this.delay = isNaN(parseInt(this.dataset.delay)) ? 0 : parseInt(this.dataset.delay);
    this.scroll = isNaN(parseInt(this.dataset.scroll)) ? 0 : parseInt(this.dataset.scroll);
    this.days = isNaN(parseInt(this.dataset.remember)) ? 0 : parseInt(this.dataset.remember);
    this.modal = new bootstrap.Modal(this);
    this.checkCanShow();

    if(this.cansShow){
      if(this.dataset.delay != undefined){
        this.handleDelay();
      }
  
      if(this.dataset.scroll != undefined){
        this.scrollHandler = this.handleScroll.bind(this);
        window.addEventListener('scroll', this.scrollHandler, false);
      }

      if(this.dataset.remember != undefined && this.days > 0){
        this.addEventListener('hidden.bs.modal', () => this.remember());
      }
    }
  }

  remember = () => {
    localStorage.setItem(this.id, Date.now() + this.days * 24 * 60 * 60 * 1000);
  } 

  checkCanShow = () => {
    const stamp = parseInt(localStorage.getItem(this.id));
    this.cansShow = false;
    if(isNaN(stamp) || stamp < Date.now() || this.dataset.remember == undefined){
      this.cansShow = true;
    }
  }

  handleScroll = () => {
    const scrollPosition = window.scrollY + window.innerHeight;
    const pageHeight = document.documentElement.scrollHeight;
    const scrollPercentage = this.scroll / 100;
    if(scrollPosition / pageHeight > scrollPercentage){
      this.showModal();
      window.removeEventListener('scroll', this.scrollHandler, false);
    }
  }

  handleDelay = () => {
    setTimeout(() => {
      this.showModal();
    }, this.delay);
  }

  showModal = () => {
    this.modal.show();
  }
}
if (!window.customElements.get("bs-modal")) {
  window.customElements.define("bs-modal", BSModal);
}